import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Endpoint {
  apiBase = environment.apiBase;

  endpoints = {
    login: 'api/Auth/Login',
    logout: 'api/Auth/Logout',
    updateUserDeviceIdRequest: 'api/Auth/UpdateUserDeviceIdRequest',
    updateUserDeviceIdConfirm: 'api/Auth/UpdateUserDeviceIdConfirm',
  };

}
